<template>
  <div class="agent-search-wrap">
    <div class="caregory-search-wrap">
      <div class="page-filter-container">
        <category-tab :activeTab="activeTab" @tabclicked="clickCategoryTab"></category-tab>
      </div>
      <div class="backdrop" @click="toggleFilter" v-show="expandFilters"></div>
      <div :class="{ expand: expandFilters }" class="filters-wrap">
        <div class="autocomplete-search-wrap">
          <autocomplete-search
            :search-options="keywordsSearchOptions"
            :placeholder="autocompletePlaceholder"
            @click.native="autocompleteClick"
            class="autocomplete-search-container"
          />
          <div class="filter-toggle-btn" @click="toggleFilter"></div>
        </div>
        <button class="search-btn-wrap" type="button" @click="searchBtnClick">
          {{ $t('find.SEARCH') }}
        </button>
        <Transition name="fade">
          <div v-show="expandFilters" class="extra-filters-wrap">
            <div class="ics-filter-wrap">
              <ics-filter
                class="filter"
                :icsType="filters.icsType"
                :canUnset="false"
                @change="updateFilter"
                textType="dept"
              >
                <!-- updatePaginate -->
              </ics-filter>
            </div>
            <div class="extra-filter-container">
              <mobile-filter-search filterType="district" :districtCount="filters.districts.length">
                <advanced-search-district
                  :ics-type="filters.icsType"
                  :selected-districts="filters.districts || []"
                  @changeDistrict="districtSearch"
                ></advanced-search-district>
              </mobile-filter-search>
            </div>
            <div class="extra-filter-container">
              <mobile-filter-search filterType="agent" :agentCount="selectedFilters">
                <agent-filter
                  :isMitaclub="filters.isMitaclub"
                  :isManager="filters.isManager"
                  :isSales="filters.isSales"
                  @updateFilter="updateFilter"
                ></agent-filter>
              </mobile-filter-search>
            </div>
            <search-reset-btn
              v-show="expandFilters"
              @resetFilters="reset"
              @mobileSearchClick="mobileSearchClick"
            ></search-reset-btn>
          </div>
        </Transition>
      </div>
    </div>
    <div class="search-criteria-wrap">
      <div class="search-criteria-container">
        <dropdown-modal :btnText="sbuBtnText" :optionSelected="sbuSelected" @reset="resetIcsFilter">
          <sbu-filter
            :icsType="filters.icsType"
            @change="updateFilter"
            targetPage="agent"
          ></sbu-filter>
        </dropdown-modal>
        <dropdown-modal
          :btnText="agentBtnText"
          :optionSelected="selectedFilters > 0"
          @reset="resetAgentFilters"
        >
          <agent-filter
            :isMitaclub="filters.isMitaclub"
            :isManager="filters.isManager"
            :isSales="filters.isSales"
            @updateFilter="updateFilter"
          ></agent-filter>
        </dropdown-modal>
        <dropdown-modal
          :btnText="districtBtnText"
          :optionSelected="filters.districts.length > 0"
          @reset="resetDistricts"
        >
          <advanced-search-district
            :ics-type="filters.icsType"
            :selected-districts="filters.districts || []"
            @changeDistrict="districtSearch"
          ></advanced-search-district>
        </dropdown-modal>
      </div>
    </div>
    <div class="mitaclub-bg">
      <mita-banner class="mitaclub-banner" fromPage="agentSearch" />
    </div>

    <div class="agent-count container-limit" v-if="!isFetchingAgents">
      {{ $t('find.WE_FIND') }} <span class="agent-count-text">{{ agentCount }} </span
      >{{ $t('find.PCS') }}{{ $t('find.AGENTS') }}
    </div>

    <div class="agent-list container-limit" v-show="!advanceSearch || !$md.mobile()">
      <div v-show="isFetchingAgents" class="spinner-wrapper">
        <div class="spinner" />
      </div>
      <agent-list
        v-if="agents.length"
        :agents="agents"
        :selectedDistricts="filters.districts"
        @showPopup="displayWechatPopup"
      />
      <paginate
        :totalPage="maxPage"
        :displayPageRange="maxPageRange"
        :frontEndFrameworkPaginationClassName="'pagination'"
        :currentSelectedPage="displayPage"
        v-show="isFetchedAgents && agents.length"
        @pageChange="pageChange"
      ></paginate>
    </div>

    <wechat-modal v-if="showModal" :wechatUrl="wechatUrl" @closePopup="closeWechatPopup" />

    <div class="footer-container">
      <my-footer />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import uriParamsMixin from '@/mixins/uriParams';
import AgentList from '@/components/Agent/List';
import MobileSearchBar from '@/components/Agent/MobileSearchBar';
import SearchBar from '@/components/Agent/SearchBar';
import Paginate from '@/components/Paginate';
import InfiniteLoading from 'vue-infinite-loading';
import WechatModal from '@/components/WechatModal';
import SuggestedStock from '@/components/Stock/SuggestedStock';
import MyFooter from '@/components/Footer';
import CategoryTab from '@/components/Search/CategoryTab';
import AutocompleteSearch from '@/components/Stock/AutocompleteSearch/DropdownInput';
import IcsFilter from '@/components/Stock/Filters/Ics';
import MobileFilterSearch from '@/components/Search/MobileFilter';
import AdvancedSearchDistrict from '@/components/Home/Filters/AdvancedSearchDistrict';
import AgentFilter from '@/components/Home/Filters/AgentType';
import SearchResetBtn from '@/components/Search/SearchResetBtn';
import DropdownModal from '@/components/Search/DropdownModal';
import MitaBanner from '@/components/Home/MitaBanner';
import SbuFilter from '@/components/Search/SbuFilter';

export default {
  mixins: [uriParamsMixin],
  components: {
    AgentList,
    MobileSearchBar,
    SearchBar,
    Paginate,
    InfiniteLoading,
    WechatModal,
    SuggestedStock,
    MyFooter,
    CategoryTab,
    AutocompleteSearch,
    IcsFilter,
    MobileFilterSearch,
    AdvancedSearchDistrict,
    AgentFilter,
    SearchResetBtn,
    DropdownModal,
    MitaBanner,
    SbuFilter,
  },
  data() {
    return {
      districts: [],
      agentPerPage: 24,
      displayPage: 1,
      useInfiniteLoading: true,
      loadingBottomState: null,
      isCompletedBottom: null,
      isLoadingBottom: null,
      advanceSearch: 0,
      showModal: false,
      mobileFilterActive: false,
      paramOptions: [
        { key: 'icsType', option: 'industrial', value: 'i' },
        { key: 'icsType', option: 'office', value: 'c' },
        { key: 'icsType', option: 'shops', value: 's' },
        { key: 'txType', option: 'sale', value: ['S'] },
        { key: 'txType', option: 'lease', value: ['L'] },
      ],
      activeTab: 'agent',
      expandFilters: false,
    };
  },
  mounted() {
    this.fetchDistricts();

    const filters = this.uriToFilters(this.$route.query, this.$route.params);

    if (filters.keywords) {
      this.setKeywords(filters.keywords);
    }

    if (filters.advanceSearch) {
      this.advanceSearch = 1;
    }
    this.updateFilter(filters);
  },
  watch: {
    keywords() {
      this.keywordSearch();
    },
    agents(value) {
      if (!this.isFetchEnd && this.agents.length && this.agents.length < this.agentPerPage) {
        this.useInfiniteLoading = true;
        this.resetInfinite();
      } else {
        this.useInfiniteLoading = false;
      }
      this.$nextTick(() => {
        if (this.$i18n.locale === 'gb') {
          window.changeToGb();
        }
      });
    },
    filters: {
      handler(value) {
        this.$router.push({
          name: 'agentList',
          ...this.filtersToUri(value),
        });
      },
      deep: true,
    },
    expandFilters: function(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    },
  },
  computed: {
    ...mapState('agents', {
      isFetchingAgents: state => state.isFetching,
      isFetchedAgents: state => state.isFetched,
      isFetchedDefaultAgents: state => state.isFetchedDefault,
      isFetchEnd: state => state.isFetchEnd,
      //stockCount: state => state.totalCount,
      agents: state => state.agents,
      agentCount: state => state.agentCount,
      actualPageSize: state => state.pageSize,
      filters: state => state.filters,
      fetchId: state => state.fetchId,
    }),
    ...mapState('stocksAutocompleteSearch', {
      keywords: state => state.selectedKeywords,
      autocompleteInput: state => state.input,
    }),
    maxPageRange() {
      if (this.$md.mobile() && !this.$md.tablet()) {
        return 3;
      }
      return 5;
    },
    maxPage() {
      let m = 0;
      if (this.agentCount > 0) {
        m = Math.ceil(this.agentCount / this.agentPerPage);
      }
      return m;
    },
    keywordsSearchOptions() {
      return {
        icsType: this.icsType,
        keywordType: 'emp',
      };
    },
    autocompletePlaceholder() {
      if (this.keywords.length > 0) return '';
      return this.$t('find.AGENT_INPUT_TEXT');
    },
    selectedFilters() {
      let ret = 0;
      if (this.filters.isMitaclub) {
        ret += 1;
      }
      if (this.filters.isManager) {
        ret += 1;
      }
      if (this.filters.isSales) {
        ret += 1;
      }
      return ret;
    },
    districtBtnText() {
      const count = this.filters.districts.length;
      if (count > 0) return `${this.$t('find.DISTRICT')}(${count})`;
      return this.$t('find.ALL_DISTRICT');
    },
    agentBtnText() {
      if (this.selectedFilters > 0) return `${this.$t('find.AGENT')}(${this.selectedFilters})`;
      return this.$t('find.ALL_AGENT');
    },
    sbuBtnText() {
      switch (this.filters.icsType) {
        case 'i':
          return this.$t('main.MIDLAND_I');
        case 'c':
          return this.$t('main.MIDLAND_C');
        case 's':
          return this.$t('main.MIDLAND_S');
        default:
          return this.$t('find.ALL_DEPT');
      }
    },
    sbuSelected() {
      if (this.filters.icsType) return true;
      return false;
    },
  },
  methods: {
    ...mapActions('agents', [
      'fetchDefaultAgents',
      'fetchMoreAgents',
      'fetchByPage',
      'updateFilter',
      'updateDistrictFilter',
    ]),
    ...mapActions('districts', ['fetchDistricts', 'setIcsType']),
    ...mapActions('stocksAutocompleteSearch', ['setKeywords', 'addKeyword']),

    resetInfinite() {
      if (this.$refs.infiniteLoadingBottom) {
        this.$refs.infiniteLoadingBottom.$emit('$InfiniteLoading:reset');
      }
    },
    icsSearch(ics) {
      this.updateFilter(ics);
      this.displayPage = 1;
    },
    keywordSearch() {
      let keywordSelected = '';
      if (this.keywords && this.keywords.length) {
        keywordSelected = this.keywords.reduce((a, k) => {
          if (a) {
            a = `${a},${encodeURIComponent(k)}`;
          } else {
            a = encodeURIComponent(k);
          }
          return a;
        }, '');
      }
      if (keywordSelected) {
        keywordSelected = `?keywords=${keywordSelected}`;
      }

      this.updateFilter({
        keywordType: 'emp',
        keywords: this.keywords.join(','),
      });
      this.displayPage = 1;
    },
    districtSearch(districts) {
      this.updateDistrictFilter(districts);
      this.displayPage = 1;
    },
    agentTypeSearch(agentType) {
      this.updateFilter(agentType);
      this.displayPage = 1;
    },
    pageChange(page) {
      this.displayPage = page;
      let actualPageToFetch = (page - 1) * Math.round(this.agentPerPage / this.actualPageSize);
      this.fetchByPage(actualPageToFetch);
      window.scrollTo(0, 0);
    },
    triggerAdvanceSearch(active) {
      this.advanceSearch = active;
    },
    infiniteBottomHandler($state) {
      if (this.isFetchedAgents && !this.isFetchEnd) {
        this.fetchMoreAgents();
      }
    },
    displayWechatPopup(url) {
      this.showModal = true;
      this.wechatUrl = url;
    },
    closeWechatPopup() {
      this.showModal = false;
      this.wechatUrl = '';
    },
    reset() {
      this.setKeywords([]);
      this.updateFilter({
        icsType: null,
        keywords: null,
        districts: [],
        isMitaclub: false,
        isManager: false,
        isSales: false,
      });
      this.displayPage = 1;
    },
    clickCategoryTab(val) {
      if (val === this.activeTab) return;
      let freetext = null;
      let category = '';
      const filters = this.uriToFilters(this.$route.query, this.$route.params);
      switch (val) {
        case 'leaseOrSale':
          category = 'find';
          break;
        case 'lease':
          category = 'find';
          filters.txType = ['L'];
          filters.nonNewProperty = '1';
          filters.nonSoleAgent = '1';
          break;
        case 'sale':
          category = 'find';
          filters.txType = ['S'];
          filters.nonNewProperty = '1';
          filters.nonSoleAgent = '1';
          break;
        case 'tx':
          category = 'transaction';
          break;
      }
      if (this.autocompleteInput) {
        freetext = {
          suggestionWord: this.autocompleteInput,
          type: 'free_text',
          value: this.autocompleteInput,
          ics: '',
        };
        freetext = JSON.stringify(freetext);
      }
      if (filters.keywords) {
        const tmpKeywords = decodeURIComponent(filters.keywords);
        const matchedKeywords = tmpKeywords.match(/(\{.*?\},?)/g);
        if (category === 'find') {
          const regex = /"street"/g;
          filters.keywords = filters.keywords.replaceAll(regex, '"addr"');

          matchedKeywords.forEach(k => {
            if (k.includes('free_text')) {
              // remove all free text keyword like phone number or licence
              filters.keywords = filters.keywords.replaceAll(k, '');
            }
          });
        } else if (category === 'transaction') {
          const regex = /"addr"/g;
          filters.keywords = filters.keywords.replaceAll(regex, '"street"');
          matchedKeywords.forEach(k => {
            // remove all keywords
            filters.keywords = filters.keywords.replaceAll(k, '');
          });
        }
        if (freetext) {
          filters.keywords = `${filters.keywords},${freetext}`;
        }
      } else {
        filters.keywords = freetext;
      }

      let uri = this.filtersToUri(filters, false);
      window.location.href = this.absoluteUrl(category, uri);
    },
    toggleFilter() {
      this.expandFilters = !this.expandFilters;
    },
    autocompleteClick(e) {
      if (e.target.className !== 'remove-keyword-icon' && window.innerWidth < 993) {
        // if not clicking remove btn
        this.expandFilters = true;
      }
    },
    searchBtnClick() {
      if (this.autocompleteInput) {
        let freetextObj = {
          suggestionWord: this.autocompleteInput,
          type: 'free_text',
          value: this.autocompleteInput,
          ics: '',
        };
        let freetext = JSON.stringify(freetextObj);
        if (this.filters.keywords) {
          const tmpKeywords = decodeURIComponent(this.filters.keywords);
          if (tmpKeywords.includes(freetext)) {
            return;
          } else freetext += `,${this.filters.keywords}`;
        }
        this.addKeyword(freetextObj);
      }
    },
    mobileSearchClick() {
      this.toggleFilter();
      this.searchBtnClick();
    },
    resetDistricts() {
      this.updateFilter({
        districts: [],
      });
    },
    resetAgentFilters() {
      this.updateFilter({
        isMitaclub: false,
        isManager: false,
        isSales: false,
      });
    },
    resetIcsFilter() {
      this.updateFilter({ icsType: null });
    },
  },
};
</script>

<style scoped>
.agent-list {
  min-height: 700px;
  margin-top: 10px;
}

.spinner-wrapper {
  min-height: 90vh;
}

.spinner-wrapper .spinner {
  margin: 50px auto 0;
  height: 28px;
  width: 28px;
  animation: rotate 0.8s infinite linear;
  border: 8px solid #fee100;
  border-right-color: transparent;
  border-radius: 50%;
}

.footer-container {
  margin-top: 50px;
}

.page-filter-container {
  padding: 16px 16px 0;
  border-bottom: 1px solid #e5e5e5;
}

.autocomplete-search-wrap {
  padding: 16px;
  background: #f7f7f9;
  position: relative;
}
.autocomplete-search-container {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}

.filter-toggle-btn {
  background-image: url('data:image/svg+xml;utf-8,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.675 18V12.375H9.175V14.45H18V15.95H9.175V18H7.675ZM0 15.95V14.45H6.175V15.95H0ZM4.675 11.8V9.75H0V8.25H4.675V6.15H6.175V11.8H4.675ZM7.675 9.75V8.25H18V9.75H7.675ZM11.825 5.625V0H13.325V2.05H18V3.55H13.325V5.625H11.825ZM0 3.55V2.05H10.325V3.55H0Z" fill="%23252525"/></svg>');
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 24px;
  right: 32px;
}

.ics-filter-wrap,
.extra-filter-container {
  padding: 0 16px 16px;
}

.ics-filter-wrap >>> .btn {
  background: white;
}

.ics-filter-wrap >>> .btn.btn-active {
  background-color: #ffe100;
  font-weight: 700;
  color: #252525;
}

.ics-filter-wrap >>> .btn-group {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
  display: flex;
  justify-content: space-between;
}

.ics-filter-wrap >>> .btn-default {
  flex-basis: 25%;
}
.backdrop {
  display: block;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100vw;
  height: 50vh;
  background: rgba(0, 0, 0, 0.25);
  z-index: 9997;
}

.expand {
  height: 75vh;
  position: absolute;
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
  z-index: 9997;
  overflow: auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
}

.filters-wrap >>> .districts-wrap {
  row-gap: 24px;
  height: auto;
}
.extra-filters-wrap {
  flex: 1;
  background: #f7f7f9;
  display: flex;
  flex-direction: column;
}

.search-btn-wrap {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter {
  opacity: 0;
  transform: translateY(-20px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.search-criteria-wrap {
  display: none;
  padding-bottom: 8px;
  border-bottom: 1px #e5e5e5 solid;
}

.search-criteria-container {
  display: flex;
  gap: 8px;
}

.extra-filter-container >>> .agent-type-wrap {
  height: auto;
}

.agent-count-text {
  color: #f6571a;
  font-weight: 700;
}

.agent-count {
  font-size: 16px;
  padding-bottom: 16px;
}

.mitaclub-bg {
  margin-bottom: 24px;
}

.container-limit {
  margin: 0 16px;
}

.agent-search-wrap >>> .keywords-list li:nth-child(n + 7) {
  display: none;
}

/* not mobile */
@media (min-width: 992px) {
  .agent-search-wrap >>> .keywords-list li:nth-child(n + 7) {
    display: block;
  }
  .page-filter-container {
    border: none;
    padding: 0;
  }

  .extra-filters-wrap,
  .backdrop,
  .filter-toggle-btn {
    display: none;
  }

  .filters-wrap {
    height: auto;
    position: static;
    overflow: initial;
    display: flex;
    flex: 1;
    flex-direction: row;
    box-shadow: none;
  }

  .autocomplete-search-wrap {
    background: none;
    padding: 0;
    flex: 1;
  }
  .caregory-search-wrap {
    display: flex;
    gap: 32px;
    padding: 24px 0 16px;
    align-items: flex-end;
    max-width: 938px;
    margin: auto;
  }
  .page-filter-container {
    border: none;
    padding: 0;
  }

  .search-btn-wrap {
    display: block;
    background: #ffe100;
    border-radius: 3px;
    border: none;
    color: #252525;
    font-weight: 700;
    font-size: 16px;
    width: 96px;
  }

  .autocomplete-search-container {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
  }

  .search-criteria-wrap {
    display: block;
  }
  .mitaclub-bg {
    background: #121212;
  }
}

/* laptop */
@media (min-width: 992px) and (max-width: 1199px) {
  .search-criteria-container,
  .container-limit,
  .mitaclub-banner {
    max-width: 938px;
    margin: auto;
  }

  .mitaclub-bg {
    margin-bottom: 32px;
  }

  .agent-search-wrap >>> .advanced-search-district .regions-container {
    flex: calc((100% - 938px) / 2 + 100% * 3 / 9);
    background: white;
  }
  .search-criteria-container >>> .districts-wrap {
    gap: 8px;
    height: -webkit-fill-available;
  }

  .search-criteria-container >>> .price-or-area-container {
    max-width: 938px;
    margin: auto;
  }

  .search-criteria-container >>> .advanced-search-district,
  .search-criteria-container >>> .regions-wrap {
    height: -webkit-fill-available;
  }
}

/* desktop */
@media (min-width: 1200px) {
  .search-filter-wrap {
    position: relative;
    gap: 12px;
  }

  .search-criteria-container {
    gap: 12px;
    position: relative;
  }
}

/* desktop 1 */
@media (min-width: 1200px) and (max-width: 1439px) {
  .search-criteria-container,
  .caregory-search-wrap,
  .container-limit,
  .mitaclub-banner {
    max-width: 1138px;
    margin: auto;
  }

  .mitaclub-bg {
    margin-bottom: 32px;
  }
}

/* desktop 2 */
@media (min-width: 1440px) {
  .search-criteria-container,
  .caregory-search-wrap,
  .container-limit,
  .mitaclub-banner {
    max-width: 1360px;
    margin: auto;
  }

  .mitaclub-bg {
    margin-bottom: 16px;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
